import DataFactory from '@rdfjs/data-model/Factory.js'

export default DataFactory
